import React from "react";
import { Button } from "@mui/material";
import { useFormik } from "formik";
import { Grid, Box, } from "@mui/material";
import DepartmentFormFields from "./DepartmentFormFields";
import TabComponent from "components-base/Tab/Tab";
import { createDepartment, modifyDepartment, validationSchemaDepartment } from "../functions";
import { useDispatch, useSelector } from "react-redux";
import { showMessage } from "store/modules/Message";

const DepartmentForm = ({ mode, handleClose }) => {
    const { defaultDataDepartment } = useSelector(({ department }) => department);
    const dispatch = useDispatch();
    const messages = (mensaje) => {
        dispatch(
            showMessage({
                message: `Departamento/Area ${mensaje} con éxito`,
                variant: "success",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            })
        );

    }
    const formik = useFormik({
        initialValues:
            mode === "POST"
                ? {
                    name: "",
                    description: "",
                    code: "",
                }
                : {
                    id: defaultDataDepartment?.id,
                    name: defaultDataDepartment?.name,
                    description: defaultDataDepartment?.description,
                    code: defaultDataDepartment?.code,
                },
        validationSchema: validationSchemaDepartment,
        onSubmit: async (values) => {
            switch (mode) {
                case "POST":
                    await createDepartment(values, dispatch);
                    messages("Creado")
                    handleClose();
                    break;
                case "PUT":
                    await modifyDepartment(values, dispatch);
                    messages("Modificado");
                    handleClose();
                    break;
                default: handleClose();
            }
        },
    },);
    const { setFieldValue } = formik;

    return (
        <Box
            component="form"
            onSubmit={formik.handleSubmit}
            sx={{
                "& .MuiTextField-root": { marginBottom: "25px" },
            }}
            style={{ padding: "20px", justifyContent: "center" }}
        >
            <TabComponent tabsElement={[
                {
                    label: "Información de departamento/area",
                    component: <DepartmentFormFields formik={formik} mode={mode} setFieldValue={setFieldValue} />
                }
            ]} />
            <Grid container
                spacing={2}
                sx={{ display: "flex", justifyContent: "flex-end", padding: 0 }}
            >
                <Grid item sx={12} >
                    <Button onClick={handleClose} color="primary" variant="contained">
                        Cancelar
                    </Button>
                </Grid>
                <Grid item sx={12}>
                    <Button color="primary" variant="contained" type="submit">
                        Guardar
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}
export default DepartmentForm;